import { Card, CardActions, CardBody, CardHeader } from '@progress/kendo-react-layout'
import CustomButton from '../../stateless/customButton/CustomButton';
import './RuleSearchCard.scss';
import HtmlRender from '../../stateless/htmlRender/HtmlRender';
// import { useRuleSearchCardController } from './RuleSearchCardController';
import React from 'react';

interface IRuleSearchCardProps {
  searchData: any;
  toggleTitleDialog: (event: any, titleId: number) => any;
  toggleChapterDialog: (event: any, chapter: any) => any;
  // getTitleChapters: (searchData: any) => void;

}

const RuleSearchCard = (props: IRuleSearchCardProps) => {
  const { searchData, toggleTitleDialog, toggleChapterDialog } = props;
  // const { subscribeToChapter } = useRuleSearchCardController();
  let title = searchData.document.TitleName === null
    ? searchData.document.TitleNumber
    : `${searchData.document.TitleNumber}, ${searchData.document.TitleName}`
  let chapter = searchData.document.ChapterName === null
    ? searchData.document.ChapterNumber
    : `${searchData.document.ChapterNumber}, ${searchData.document.ChapterName}`;
  let effectiveDate = searchData.document.EffectiveDate && new Date(searchData.document.EffectiveDate);

  return (
    <Card className="search-card" navigatable>
      <CardHeader className="search-card-header">
        <div>{ `Agency, ${searchData.document.AgencyName}` }</div>
        <div>{ `Title ${title}` }</div>
        <div>{ `Chapter ${chapter}` }</div>
        {effectiveDate && (
        <div>
          {`Effective: ${effectiveDate.getMonth() + 1}/${effectiveDate.getDate()}/${effectiveDate.getFullYear()}`}
        </div>
        )}
      </CardHeader>
      <CardBody className="search-card-body">
        <HtmlRender value={searchData.document.UpdatedChapterHtml ?? ""} />
      </CardBody>
      <CardActions>
        <CustomButton fillMode='flat' onClick={
          (event) => toggleTitleDialog(event, searchData.document.TitleId)
        }>
          View Title
        </CustomButton>
        <CustomButton fillMode='flat' onClick={(event) => toggleChapterDialog(event, searchData.document)}>
          View Chapter
        </CustomButton>
        {/* TODO: This button needs to conditionally show when a user is signed in */}
        {/* {localStorage.getItem('subscriptionUser') ?
        <CustomButton onClick={() => subscribeToChapter(searchData.document)}>
          Subscribe to Chapter
        </CustomButton> : null} */}
      </CardActions>
    </Card>
  )
}

export default RuleSearchCard